module.exports = __webpack_public_path__ + "img/magento.3f67e4a1.png";